import { createFileRoute } from "@tanstack/react-router";
import ReferenzenPage from "@/pages/ReferenzenPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/referenzen/")({
  head: () =>
    buildRouteHead({
      title: "Referenzen | Erfolgreiche Webprojekte aus Wernigerode",
      description:
        "Entdecken Sie Webdesign-Referenzen aus Wernigerode und dem Harz: Arztpraxen, Hotels, Vereine, Steuerberater und mehr.",
      path: "/referenzen",
      image: "/images/hero-bg-1280.webp",
      imageAlt: "Referenzen der Agentur Enno & Jens",
      imageWidth: 1280,
      imageHeight: 720,
    }),
  component: ReferenzenPage,
});
